import React from 'react'
import { Banner } from 'src/components/Banner'
import { Button } from 'src/components/Button'
import { Input } from 'src/components/Input'
import { DefaultFormStyle as S } from 'src/pages/DefaultJoinFormPage/styled'
import DefaultFooter from 'src/components/Footer/DefaultFooter'
import PaidNoticeText from 'src/components/PaidNoticeText'
import AgencyTabList from 'src/components/AgencyTabList'
import RenderIf from 'src/components/RenderIf'
import { useFormContext } from 'react-hook-form'
import { AllTermsBooleanType, JoinFormType } from 'src/types/react-hook-form'
import styled from 'styled-components'
import { RecaptchaVerifierRef } from 'src/pages/RecaptchaJoinFormPage/components/RecaptchaVerifier'
import { RecaptchaJoinFormPageProps } from 'src/pages/RecaptchaJoinFormPage/index'

interface RecaptchaJoinFormPageViewProps extends RecaptchaJoinFormPageProps {
  AuthToken: string | null
  onAuthTokenChange: (token: string) => void
  onRecaptchaError: (error: Error) => void
  recaptchaError: string | null
  isRecaptchaLoading: boolean
  recaptchaRef: React.RefObject<RecaptchaVerifierRef>
}

const RecaptchaJoinFormPageView: React.FC<RecaptchaJoinFormPageViewProps> = (props) => {
  const {
    dynamicUiData: { FooterContent, NotiContent, ButtonMsgAfter, TopImage, MiddleImage, UIData },
    registerAttributeExcludeAllTerms: termsData,
    resetFormItems,
    registerAttribute,
    otpCertRequest,
    otpCertVerify,
    count,
    isRecaptchaLoading,
  } = props

  const {
    handleSubmit,
    getValues,
    register,
    formState: { touchedFields },
  } = useFormContext<JoinFormType>()

  const { layoutsFooter, layoutsInsert, layoutsTerms, layoutsVerify, layoutsConfirm } = UIData
  const handleSubmitOtpCertRequest = handleSubmit(otpCertRequest.submit, otpCertRequest.error)
  const handleSubmitOtpVerify = handleSubmit(otpCertVerify.submit, otpCertVerify.error)
  return (
    <S.DefaultFormContainer>
      <Banner.Container>
        <Banner.Items img={TopImage} id="top_Image" />
        <Banner.Items img={MiddleImage} id="middle_Image" />
      </Banner.Container>

      <S.CertFormContainer onSubmit={(e) => e.preventDefault()} $mainBg={layoutsInsert?.mainBg}>
        <AgencyTabList {...props} layoutsInsert={layoutsInsert} />
        <S.CertFormContents $gap={layoutsInsert?.certs?.type}>
          <Input.PNumber
            registerAttribute={registerAttribute}
            keyDownFunc={handleSubmitOtpCertRequest}
            style={S.CertInputStyle({ touch: true, ...layoutsInsert?.certs })}
          />

          <Button.OtpCertRequest
            onClick={handleSubmitOtpCertRequest}
            renderIf={getValues('TranID') === ''}
            disabled={isRecaptchaLoading}
            $style={S.OtpRequestButton({
              ...layoutsConfirm?.submitBtn,
            })}
          />

          <RenderIf when={getValues('TranID') !== ''}>
            <S.OtpFormContainer>
              <S.ApprovalNumberContainer>
                <S.ApprovalNumberInputWrap>
                  <Input.ApprovalNumber
                    registerAttribute={registerAttribute}
                    keyDownFunc={handleSubmitOtpVerify}
                    style={S.CertInputStyle({
                      touch: touchedFields?.ApprovalNumber !== undefined,
                      ...layoutsInsert?.certs,
                    })}
                  />
                  <S.Timer>{count?.substring(4, 12)}</S.Timer>
                </S.ApprovalNumberInputWrap>
              </S.ApprovalNumberContainer>

              <Button.RetryOtpCertRequest
                $style={{
                  ...S.RetryRequestButton,
                }}
                onClick={handleSubmitOtpCertRequest}
                disabled={isRecaptchaLoading}
              />
            </S.OtpFormContainer>
          </RenderIf>
        </S.CertFormContents>

        <S.JoinTermsWrap>
          <S.JoinTermsItem type="all">
            <S.FormCheckboxLabel type={'all'}>
              <S.FormCheckbox
                $actColor={layoutsTerms?.actColor}
                {...register('allTerms', registerAttribute.allTerms?.register_options)}
                onClick={registerAttribute.allTerms?.register_options?.onClick}
              />
              필수약관 모두 동의
            </S.FormCheckboxLabel>
          </S.JoinTermsItem>

          {termsData?.map((termsItems) => {
            const { tag, termsTitle, register_options, showTermsPopup } = termsItems
            return (
              <S.JoinTermsItem type="each" key={tag}>
                <S.FormCheckboxLabel type={'each'}>
                  <S.FormCheckbox
                    $actColor={layoutsTerms?.actColor}
                    {...register(tag as keyof AllTermsBooleanType, register_options)}
                  />
                  {termsTitle}
                </S.FormCheckboxLabel>
                <S.JoinTermsOpenDesc onClick={showTermsPopup}>보기</S.JoinTermsOpenDesc>
              </S.JoinTermsItem>
            )
          })}
        </S.JoinTermsWrap>

        <Button.JoinSubmit
          onClick={handleSubmitOtpVerify}
          $style={S.JoinButton({ ...layoutsVerify?.verifyBtn })}
          name={ButtonMsgAfter}
        />
        <Button.CancelReset
          onClick={resetFormItems}
          $style={S.CancelReset({ ...layoutsVerify?.cancelBtn })}
        />
      </S.CertFormContainer>

      <PaidNoticeText NotiContent={NotiContent} notiCashSpace={layoutsVerify?.cashSpace} />
      <DefaultFooter content={FooterContent} layoutsFooter={layoutsFooter} />

      <RecaptchaNotice>
        이 사이트는 reCAPTCHA로 보호되며,&nbsp;
        <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer">
          Google 개인정보처리방침
        </a>
        &nbsp;및&nbsp;
        <a href="https://policies.google.com/terms" target="_blank" rel="noopener noreferrer">
          서비스 약관
        </a>
        이 적용됩니다.
      </RecaptchaNotice>
    </S.DefaultFormContainer>
  )
}

export default RecaptchaJoinFormPageView

const RecaptchaNotice = styled.div`
  font-size: 11px;
  color: #666;
  text-align: center;
  padding: 10px 0 20px;
  line-height: 1.4;
  word-break: keep-all;

  a {
    color: #666;
    text-decoration: underline;
  }
`
